import axios from 'axios';

export default {
  downloadProductsExport(report) {
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/products/reports?report=${report}`;
    return axios({
          url: url,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', 'Products.xlsx'); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  listProductDefinitionV2 (params, xPortausInclude) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/product-definitions",
      {
        params : params,
        headers: {
          'X-Portaus-Include': xPortausInclude,
        }
      })
      .then(response=>{
        return response.data;
      })
  },
  listProductsV2 (params, xPortausInclude) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/products",
      {
        params : params,
        headers: {
          'X-Portaus-Include': xPortausInclude,
        }
      })
      .then(response=>{
        return response.data;
      })
  },
  getProductPriceV2 (productId, params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/products/" + productId+ "/price", {params : params})
      .then(response=>{
        return response.data;
      })
  },
  getProductDefinitionV2(productId, params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/product-definitions/"+productId, {params : params})
      .then(response=>{
        return response.data;
      })
  },
  getProductV2(productId, params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/products/"+productId, {params : params})
      .then(response=>{
        return response.data;
      })
  },
  // DEPRECATED
  listProducts(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/products/", {params : params})
      .then(response=>{
        return response.data;
      })
  },
  getStats(){
    let params ={summary:true};
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/products/", {params : params})
      .then(response=>{
        return response.data;
      })
  },
  //DEPRECATED
  createProduct(productToCreate){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/products", productToCreate)
      .then(response=>{
        return response.data;
      })
  },
  createProductV2(productToCreate){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/product-definitions", productToCreate)
      .then(response=>{
        return response.data;
      })
  },
  //DePRECATED
  // deleteProduct(productId){
  //   return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/products/"+productId)
  //     .then(response=>{
  //       return response.data;
  //     })
  // },
  deleteProduct(productId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/product-definitions/"+productId)
      .then(response=>{
        return response.data;
      })
  },
  // DEPRECATED
  updateProduct(productToUpdate){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/products/"+productToUpdate.id, productToUpdate)
      .then(response=>{
        return response.data;
      })
  },
  updateProductV2(productId, productToUpdate, xPortausInclude){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/product-definitions/"+productId, productToUpdate, {
      headers: {
        'X-Portaus-Include': xPortausInclude,
      }
    })
      .then(response=>{
        return response.data;
      })
  },
  // DEPRECATED use getProductV2 instead
  findProduct(productId, params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/products/"+productId, {params : params})
      .then(response=>{
        return response.data;
      })
  },
  validate(actualSku, params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/products/validate", {params : params, headers : {'x-sku':actualSku}})
      .then(response=>{
        return response.data;
      })
  }

}
